module.exports = __webpack_public_path__ + "img/bjsfzgzc_position_img.1a44e9cb.png";